import React, { useEffect, useMemo, useRef, useState } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import SingleProgramContent from './SingleProgramContent'
import MultipleThemes from './MultipleThemes'
import { useDeeplink } from 'hooks/useDeeplink'

import classes from './index.module.scss'
import { mcaScreenerPromise } from 'apis/FitOnCareAPI'
import { useMetadataOptions } from 'hooks/careHooks'
import { LoadingContent } from 'components/LoadingDialog/index'
import { useRehabSelectedThemes } from 'contexts/AuthContext'

const { styles } = classes

const RehabCongratulations = (props) => {
  const { sku, fitonUserId } = props
  const { theme } = useDeeplink()
  const { mcaMskBodyAreas } = useMetadataOptions()
  const [currentFitonUserId, setCurrentFitonUserId] = useState(fitonUserId)
  const [mcaBodyAreas, setMcaBodyAreas] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const hasFetchedMcaScreenerRef = useRef(false)
  const { rehabSelectedThemes } = useRehabSelectedThemes()

  useEffect(() => {
    setCurrentFitonUserId(fitonUserId)
  }, [fitonUserId])

  useEffect(() => {
    if (sku !== 'mca') {
      setIsLoading(false)
      return
    }

    if (_.isEmpty(mcaMskBodyAreas) || hasFetchedMcaScreenerRef.current) {
      return
    }

    hasFetchedMcaScreenerRef.current = true
    const bodyAreaOptions = mcaMskBodyAreas

    mcaScreenerPromise()
      .then((resp) => {
        const fitonUserId = resp.data?.fitonUserId?.toString()
        const mcaBodyAreas = resp.data?.bodyAreas
        setCurrentFitonUserId(fitonUserId)
        setMcaBodyAreas(
          mcaBodyAreas?.map((area) =>
            _.find(bodyAreaOptions, { value: area })
          ) || []
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [sku, mcaMskBodyAreas])

  useEffect(() => {
    props.setRemoveEventListener(true)
  }, [])

  const isSingleProgram = useMemo(() => {
    return !!theme || mcaBodyAreas?.length === 1
  }, [theme, mcaBodyAreas])

  const selectedThemes = useMemo(() => {
    return sku === 'mca' ? mcaBodyAreas : rehabSelectedThemes
  }, [sku, rehabSelectedThemes, mcaBodyAreas])

  return (
    <div
      className={classnames(styles, 'info-sec')}
      style={{ minHeight: '100%' }}
    >
      {isLoading ? (
        <div className='loading-content'>
          <LoadingContent />
        </div>
      ) : (
        <>
          {isSingleProgram ? (
            <SingleProgramContent
              {...props}
              fitonUserId={currentFitonUserId}
              themes={selectedThemes}
            />
          ) : (
            <MultipleThemes
              {...props}
              fitonUserId={currentFitonUserId}
              themes={selectedThemes}
            />
          )}
        </>
      )}
    </div>
  )
}

export default RehabCongratulations
